var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "sh": "Product",
            "tabActive": "Cotton & Basic Line",
            "bg": "/images/sub/visual/sv-product.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('sub-section', {
    staticClass: "page-section--first page-section--last"
  }, [_c('sub-product', {
    attrs: {
      "tit": "Cotton & Basic Line",
      "file": "cotton"
    }
  }, [_vm._v(" Single/Double Knit, Rib, Terry, Tricot with BCI, US, Organic cotton and blended fiber. From premium cotton fabrics to affordable options. We produce any basic knit item, with reasonable price & without cotton origin problem. ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }